export default ( dataURL, cB ) => {
    fetch(dataURL)
    .then(res => res.blob())
        .then(blob => {
        var x = new XMLHttpRequest();
            x.onload = () => { 
                if ( x.readyState == 4 && x.status == 200 ) {
                    var resp = JSON.parse(x.responseText);
                    if ( !resp.url ) return;
                    cB({ url: resp.url });
                }
            }
            x.upload.onprogress = e => cB({ progress: { total: e.total, progress: e.loaded }});
            x.open('POST','https://api-v2.dev.memberstar.club/saveIMG?key=01c3cb5a33f0b47e8d3e9e4521f4ba4a')
            //x.open('POST','http://localhost:5555/saveIMG?key=01c3cb5a33f0b47e8d3e9e4521f4ba4a');
            x.send(blob);
    });
}